PaymentLocationInterceptor = ($rootScope, $location, PaymentService, AuthService) ->
  paymentRequired = (route) ->
    route?.$$route?.permission?.paymentRequired

  $rootScope.$on "$routeChangeStart", (event, next, current) ->
    return if PaymentService.paid()
    return unless paymentRequired(next)

    event.preventDefault()

    return unless AuthService.isSignedIn()

    # when access directly
    unless current
      $location.path '/'
      return

    # when redirect after login to previous page
    if current.$$route.originalPath == '/session/new'
      $location.path '/'
      return

    PaymentService.payModal()

PaymentLocationInterceptor.$inject = [
  '$rootScope'
  '$location'
  'PaymentService'
  'AuthService'
]

module.exports = PaymentLocationInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/payment-location-interceptor.coffee